import React , {Component} from 'react';
import './Contain.scss';

export default class Contain extends Component {

    render() {
	    const {children, ...otherProps} = this.props;
	    const childrenWithProps = React.Children.map(children, (child) => { return child ? React.cloneElement(child, otherProps) : ''});
	    
        return (
            <div className="m-contain">
                {childrenWithProps}
            </div>
        )
    }
}





// WEBPACK FOOTER //
// ./src/common/components/contain/Contain.jsx